import {
  setCurUserSignUp,
  getSessionId,
  setUserActorSignUpId,
  getCurUserSignUp,
  getUserActorSignUpId,
  setWebSessionKey,
  cleanObjectProperties,
  setCustomCouponCode,
  setCustomProductInfo,
  errorPageRedirect,
} from "../helpers";
import { createModel } from "@rematch/core";
import {
  IActorStageName,
  IActorFilmCenter,
  IActorPhone,
  IActorError,
  IActorAccountDto,
  IActorSignUpDto,
  IAccountCredentials,
  IAccountInfo,
  IAccountRequestData,
  IActorFilmCenterTrial,
} from "../shared/api/dtos/IActorDto";
import * as ActorRegistrationApi from "../shared/api/ActorRegistration.api";
import * as SignupApi from "../shared/api/ActorSignUp.api";
import * as ProfileManagementApi from "../shared/api/ProfileManagement.api";
import {
  IError,
  IApiResponseError,
  IEmailValidationError,
} from "../shared/api/dtos/IApiRepsonseError";
// @ts-ignore
import { getSessionDataFromAuthToken, setUserAuthToken } from "cwb-react";
// @ts-ignore
import * as Sentry from "@sentry/react";
import {
  IActorSignupResponseDto,
  IBaseSignupCredentials,
  ISignupAccountDto,
  ISignupDetails,
  ISignupResidence,
} from "shared/api/dtos/ISignupDto";
import i18next from "i18next";

const actorModel = createModel({
  state: {
    sessionId: "",
    isLoading: false,
    actorCredentials: {} as IBaseSignupCredentials,
    actorStageName: {} as IActorStageName,
    actorFilmCenter: {} as IActorFilmCenter,
    actorPhone: {} as IActorPhone,
    errors: {} as IActorError,
    fields: {} as any,
    accountCredentials: {} as IAccountCredentials,
    accountRequestData: {} as IAccountRequestData,
    accountConfirmed: false,
    invalidAccount: false,
    clientId: "",
    serviceCodeError: 0,
    residenceNotMatch: null,
    selectPhone: false,
    trialServicesWorkflow: null,
    customCouponCode: '',
    customProductCode: null,
    customProductServiceId: null,
    validationError: false,
    signupStageStartup: null,
    isEmailVerified: false,
  },
  reducers: {
    setIsLoading: (state: any, isLoading: boolean) => ({
      ...state,
      isLoading,
    }),
    setErrors: (state: any, errors: IActorError) => ({
      ...state,
      errors,
    }),
    setActorCredentials: (state: any, actorCredentials: any) => ({
      ...state,
      actorCredentials,
    }),
    setAccountCredentials: (
      state: any,
      accountCredentials: IAccountCredentials
    ) => ({
      ...state,
      accountCredentials,
    }),
    appendAccountRequestData: (state: any, payload: any) => ({
      ...state,
      accountRequestData: {
        ...payload,
      },
    }),
    setAccountConfirmed: (state, accountConfirmed: boolean) => ({
      ...state,
      accountConfirmed,
    }),
    setInvalidAccount: (state, invalidAccount: boolean) => ({
      ...state,
      invalidAccount,
    }),
    setClientId: (state, clientId: string) => ({
      ...state,
      clientId,
    }),
    setServiceCodeError: (state, code: number) => ({
      ...state,
      serviceCodeError: code,
    }),
    setResidenceNotMatch: (state, status: boolean) => ({
      ...state,
      residenceNotMatch: status,
    }),
    setSelectPhone: (state: any, phoneSelected: boolean) => ({
      ...state,
      selectPhone: phoneSelected,
    }),
    setTrialServicesWorkflow: (state: any, trialServicesWorkflow: boolean) => ({
      ...state,
      trialServicesWorkflow: trialServicesWorkflow
    }),
    setCustomCouponCode: (state: any, couponCode: string) => ({ ...state, customCouponCode: couponCode }),
    setCustomProductInfo: (state: any, productInfo: any) => ({ ...state, customProductCode: productInfo?.productCode, customProductServiceId: productInfo?.productServiceId }),
    setValidationError: (state: any, validationError: boolean) => ({ ...state, validationError: validationError }),
    setSignupStageStartup: (state: any, signupStageStartup: boolean) => ({ ...state, signupStageStartup }),
    setEmailVerified: (state: any, isEmailVerified: boolean) => ({ ...state, isEmailVerified }),
  },
  effects: (dispatch: any) => ({
    async createActorAccount(dto: IBaseSignupCredentials, state: any) {
      cleanObjectProperties(dto);
      dispatch.actorModel.setIsLoading(true);
      dispatch.actorModel.setActorCredentials(dto);

      await SignupApi.createAccountTemp(
        dto,
      ).then((resp: any) => {
        let actorDto: ISignupAccountDto = resp!.data;

        if (actorDto) {
          actorDto.signupCredentials = dto;
          dispatch.actorModel.setErrors({} as IActorError);
          setCurUserSignUp(null); // clear user in case pick diff account type and went through one step
          setCurUserSignUp(actorDto);
        }
      }).catch((resp) => {
        Sentry.captureException(resp);
        setCurUserSignUp(null);
        let apiResponseError: IApiResponseError = resp;

        const passwordErrors = resp.isPasswordWeak
          ? { Password: i18next.t("Password too weak") }
          : {};

        if (resp.isAlreadyRegistered) {
          dispatch.actorModel.setErrors({
            ...passwordErrors,
            Email: i18next.t("Email belongs to an existing account"),
          });
        } else if (resp.isEmailAlreadyExists) {
          dispatch.actorModel.setErrors({
            ...passwordErrors,
            Email: i18next.t("Email already in use"),
          });
        } else if (resp.isEmailInvalid) {
          dispatch.actorModel.setErrors({
            ...passwordErrors,
            Email: i18next.t("Invalid email"),
          });
        } else if (apiResponseError.errors) {
          dispatch.actorModel.setErrors({
            ...passwordErrors,
            ...getActorErrors(apiResponseError.errors),
          });
        } else if (apiResponseError.message) {
          dispatch.actorModel.setErrors({
            ...passwordErrors,
            errorMessage: apiResponseError.message,
          });
        } else {
          dispatch.actorModel.setErrors({...passwordErrors, unknownError: "true"});
        }
        console.error(resp);
      });
      dispatch.actorModel.setIsLoading(false);
    },
    async verifyActorEmail(code: any, state: any) {
      dispatch.actorModel.setIsLoading(true);
      //aaa
      const user: ISignupAccountDto = getCurUserSignUp();
      await SignupApi.verifyAccountEmail(getSessionId(), code)
        .then((resp: any) => {
          dispatch.actorModel.setIsLoading(false);
          let actorDto: IActorSignupResponseDto = resp!.data;
          if (actorDto) {
            dispatch.actorModel.setErrors({} as IActorError);
            setCurUserSignUp({ ...user, ...actorDto });
          }
        })
        .catch((resp) => {
          const { status } = resp;
          if (status >= 500) Sentry.captureException(resp);

          dispatch.actorModel.setIsLoading(false);
          let apiResponseError: IApiResponseError = resp;

          if (resp.isInvalidVerificationCode) {
            dispatch.actorModel.setErrors({
              Code: i18next.t("Incorrect code, please try again")
            });
          } else if (apiResponseError.errors) {
            dispatch.actorModel.setErrors(
              getActorErrors(apiResponseError.errors)
            );
          } else if (apiResponseError.message) {
            dispatch.actorModel.setErrors({
              errorMessage: apiResponseError.message,
            });
          }
          console.error(resp);
        });
    },
    async verifyActorPhone(code, state: any) {
      dispatch.actorModel.setIsLoading(true);

      await SignupApi.verifyAccountPhone(
        getSessionId(),
        code,
      ).then((resp: any) => {
        let actorDto: IActorSignupResponseDto = resp!.data;
        if (actorDto) {
          dispatch.actorModel.setErrors({} as IActorError);
          setCurUserSignUp(actorDto);
        }
      }).catch((resp) => {
        const { status } = resp;
        if (status >= 500) Sentry.captureException(resp);
        let apiResponseError: IApiResponseError = resp;
        if (apiResponseError.errors) {
          dispatch.actorModel.setErrors(
            getActorErrors(apiResponseError.errors)
          );
        } else if (apiResponseError.message) {
          dispatch.actorModel.setErrors({
            errorMessage: apiResponseError.message,
          });
        }
        console.error(resp);
      });
      dispatch.actorModel.setIsLoading(false);
    },
    async createStageName(dto: ISignupDetails & { isLoadingDisabled: boolean }, state: any) {
      cleanObjectProperties(dto);

      if (!dto.isLoadingDisabled) {
        dispatch.actorModel.setIsLoading(true);
      }
      const user: ISignupAccountDto = getCurUserSignUp();
      user.signupDetails = dto;

      await SignupApi.createAccountStagename(
        getSessionId(), dto
      ).then((resp: any) => {
        const isSuccessful = resp!.data;
        if (isSuccessful) {
          dispatch.actorModel.setErrors({} as IActorError);
          setCurUserSignUp(user);
        }
      }).catch((resp) => {
        Sentry.captureException(resp);
        // setCurUserSignUp(null);
        let apiResponseError: IApiResponseError = resp;
        if (apiResponseError.errors) {
          dispatch.actorModel.setErrors(
            getActorErrors(apiResponseError.errors)
          );
        } else if (apiResponseError.message) {
          dispatch.actorModel.setErrors({
            errorMessage: apiResponseError.message,
          });
        }
        console.error(resp);
      });
      dispatch.actorModel.setIsLoading(false);
    },
    async createActorResidence(dto: ISignupResidence, state: any) {
      cleanObjectProperties(dto);
      dispatch.actorModel.setIsLoading(true);
      const user: ISignupAccountDto = getCurUserSignUp();
      user.signupResidence = dto;

      await SignupApi.createAccountResidence(
        getSessionId(),
        dto,
      ).then((resp: any) => {
        setCurUserSignUp(user);
        const isSuccessful = resp!.data;
        if (isSuccessful) {
          dispatch.actorModel.setErrors({} as IActorError);
          setCurUserSignUp(user);
        }
      }).catch((resp: any) => {
        Sentry.captureException(resp);
        setCurUserSignUp(null);
        let apiResponseError: IApiResponseError = resp;
        if (apiResponseError.errors) {
          dispatch.actorModel.setErrors(
            getActorErrors(apiResponseError.errors)
          );
        } else if (apiResponseError.message) {
          dispatch.actorModel.setErrors({
            errorMessage: apiResponseError.message,
          });
        }
        console.error(resp);
      });
      dispatch.actorModel.setIsLoading(false);
    },
    async createActorAccountPartial(payload: { direct?: boolean, recaptchaToken?: string,  information?: string }, state: any) {
      dispatch.actorModel.setIsLoading(true);

      try {
        const resp = await SignupApi.createAccountPartial(
          getSessionId(),
          payload?.direct,
          payload?.recaptchaToken,
          payload?.information,
        );

        let actorSignUp: IActorSignupResponseDto = resp!.data;
        if (actorSignUp) {
          dispatch.actorModel.setErrors({} as IActorError);
          const signUpId = (actorSignUp.actorSignUpId ||
            actorSignUp.clientId)!.toString();
          setUserActorSignUpId(signUpId);

          const clientId = actorSignUp.clientId;
          if (clientId) {
            dispatch.actorModel.setClientId(clientId);
          }

          const jwtToken = resp!.data.jwt;
          if (jwtToken) {
            setUserAuthToken(jwtToken);
            let data = await getSessionDataFromAuthToken(jwtToken);
            let webSessionKey = data.WebSessionKey;
            setWebSessionKey(webSessionKey);
          }
        }

        return resp;
      } catch (resp) {
        if ((resp as any).error) {
          if ((resp as any).isInRegistrationProcess) {
            let params = new URLSearchParams(window.location.search);
            if ((resp as any).clientId > 0) {
              params.append('login', (resp as any).clientId)
            }
            window.location.assign(`${process.env.REACT_APP_CWB_Site}/login/go?${params}`);
          } else if (
            (resp as any).missingRecaptchaToken 
            || (resp as any).lowScore 
            || (resp as any).informationFailed
            || (resp as any).recaptchaError
            ) {
            const errorKeys = ['missingRecaptchaToken', 'lowScore', 'informationFailed'];
            const resultString = errorKeys.find(key => (resp as any)[key]);
            if (resultString)
              window.location.href = `/failConfirm?reason=${resultString}`;
            else
              errorPageRedirect("recaptchaError")
          }
        } else if ((resp as any).status === 400) {
          dispatch.actorModel.setValidationError(true);
        } else {
          Sentry.captureException(resp);
          setUserActorSignUpId(null);
          setCurUserSignUp(null);
        }
        let apiResponseError = resp as IApiResponseError;
        if (apiResponseError.errors) {
          dispatch.actorModel.setErrors(
            getActorErrors(apiResponseError.errors)
          );
        } else if (apiResponseError.message) {
          dispatch.actorModel.setErrors({
            errorMessage: apiResponseError.message,
          });
        }
        console.error(resp);
      } finally {
        dispatch.actorModel.setIsLoading(false);
      }
    },
    async createActorAccountComplete() {
      dispatch.actorModel.setIsLoading(true);

      try {
        await SignupApi.createAccountComplete(
          getSessionId(),
        );
      } catch (resp) {
        if ((resp as any).status === 400) {
          dispatch.actorModel.setValidationError(true);
        } else {
          Sentry.captureException(resp);
          setUserActorSignUpId(null);
          setCurUserSignUp(null);
        }
        let apiResponseError = resp as IApiResponseError;
        if (apiResponseError.errors) {
          dispatch.actorModel.setErrors(
            getActorErrors(apiResponseError.errors)
          );
        } else if (apiResponseError.message) {
          dispatch.actorModel.setErrors({
            errorMessage: apiResponseError.message,
          });
        }
        console.error(resp);
      } finally {
        dispatch.actorModel.setIsLoading(false);
      }
    },

    async createActorPhone(dto: IActorPhone, state: any) {
      cleanObjectProperties(dto);
      dispatch.actorModel.setIsLoading(true);
      await ActorRegistrationApi.createActorPhone(getSessionId(), dto)
        .then((resp: any) => {
          dispatch.actorModel.setIsLoading(false);
          let actorDto: IActorAccountDto = resp!.data;
          if (actorDto) {
            dispatch.actorModel.setErrors({} as IActorError);
            setCurUserSignUp(actorDto);
          }
        })
        .catch((resp) => {
          Sentry.captureException(resp);
          let apiResponseError: IApiResponseError = resp;
          if (apiResponseError.errors) {
            dispatch.actorModel.setErrors(
              getActorErrors(apiResponseError.errors)
            );
          } else if (apiResponseError.message) {
            dispatch.actorModel.setErrors({
              errorMessage: apiResponseError.message,
            });
          }
          dispatch.actorModel.setIsLoading(false);
          console.error(resp);
        });
    },
    async verifyEmailResendCode(email: string, state: any) {

      const sessionId = getSessionId();
      if (!sessionId) {
        errorPageRedirect("Missing session id");
        return;
      }

      dispatch.actorModel.setIsLoading(true);
      await SignupApi.verifyEmailResendCode({ email, sessionId: getSessionId() })
        .then((resp: any) => {
          dispatch.actorModel.setIsLoading(false);
          let actorDto: IActorAccountDto = resp!.data;
          if (actorDto) {
            dispatch.actorModel.setErrors({} as IActorError);
            setCurUserSignUp(actorDto);
          }
        })
        .catch((resp) => {
          const { status } = resp;
          if (status >= 500) Sentry.captureException(resp);
          dispatch.actorModel.setIsLoading(false);
          let apiResponseError: IApiResponseError = resp;
          if (apiResponseError.errors) {
            dispatch.actorModel.setErrors(
              getActorErrors(apiResponseError.errors)
            );
          } else if (apiResponseError.error) {

            // let validationError: IEmailValidationError = resp;
            const passwordErrors = resp.isPasswordWeak
              ? { Password: i18next.t("Password too weak") }
              : {};

            if (resp.isAlreadyRegistered) {
              dispatch.actorModel.setErrors({
                ...passwordErrors,
                Email: i18next.t("Email belongs to an existing account"),
              });
            } else if (resp.isEmailAlreadyExists) {
              dispatch.actorModel.setErrors({
                ...passwordErrors,
                Email: i18next.t("Email already in use"),
              });
            } else if (resp.isEmailInvalid) {
              dispatch.actorModel.setErrors({
                ...passwordErrors,
                Email: i18next.t("Invalid email"),
              });
            } else if (apiResponseError.errors) {
              dispatch.actorModel.setErrors({
                ...passwordErrors,
                ...getActorErrors(apiResponseError.errors),
              });
            } else if (apiResponseError.message) {
              dispatch.actorModel.setErrors({
                ...passwordErrors,
                errorMessage: apiResponseError.message,
              });
            }
          }

          console.error(resp);
        });
    },
    async createTrialSignUp(dto: IActorFilmCenter, state: any) {
      cleanObjectProperties(dto);
      dispatch.actorModel.setIsLoading(true);
      let user: IActorAccountDto = getCurUserSignUp();
      user.actorFilmCenter = dto;
      try {
        const resp = await ActorRegistrationApi.createTrialSignUp(
          getSessionId(),
          dto,
          dto.dev
        );
        setCurUserSignUp(user);
        let actorSignUp: IActorSignUpDto = resp!.data;
        if (actorSignUp) {
          dispatch.actorModel.setErrors({} as IActorError);
          const signUpId = (actorSignUp.actorSignUpId ||
            actorSignUp.clientId)!.toString();
          setUserActorSignUpId(signUpId);
          const urlParams = new URLSearchParams(window.location.search);
          const devParam = urlParams.get("dev");
          let isDev = false;
          if (devParam && devParam === "1") isDev = true;
          const resp: any = await ActorRegistrationApi.createTrialUser(
            getUserActorSignUpId(),
            isDev
          );
          const clientId = resp!.data.clientId;
          const jwtToken = resp!.data.jwt;
          if (jwtToken) {
            setUserAuthToken(jwtToken);
            let data = await getSessionDataFromAuthToken(jwtToken);
            let webSessionKey = data.WebSessionKey;
            setWebSessionKey(webSessionKey);
          }
          dispatch.actorModel.setClientId(clientId);
          dispatch.actorModel.setIsLoading(false);
        }
      } catch (resp) {
        if ((resp as any).status === 400) {
          dispatch.actorModel.setValidationError(true);
        } else {
          Sentry.captureException(resp);
          setUserActorSignUpId(null);
          setCurUserSignUp(null);
        }
        let apiResponseError = resp as IApiResponseError;
        if (apiResponseError.errors) {
          dispatch.actorModel.setErrors(
            getActorErrors(apiResponseError.errors)
          );
        } else if (apiResponseError.message) {
          dispatch.actorModel.setErrors({
            errorMessage: apiResponseError.message,
          });
        }
        console.error(resp);
      }
    },
    async createCodeTrialSignUp(dto: IActorFilmCenterTrial, state: any) {
      cleanObjectProperties(dto);
      dispatch.actorModel.setIsLoading(true);
      const user: IActorAccountDto = getCurUserSignUp();
      const serviceCode = dto.serviceCode;
      const aId = dto.aId;
      const dId = dto.dId;
      const filmDto: IActorFilmCenter = JSON.parse(
        JSON.stringify(dto, function (key, value) {
          if (key === "serviceCode" || key === "aId" || key === "dId") {
            return undefined;
          } else {
            return value;
          }
        })
      );
      user.actorFilmCenter = filmDto;
      try {
        const resp = await ActorRegistrationApi.createTrialSignUp(
          getSessionId(),
          filmDto,
          dto.dev
        );
        setCurUserSignUp(user);
        let actorSignUp: IActorSignUpDto = resp!.data;
        if (actorSignUp) {
          dispatch.actorModel.setErrors({} as IActorError);
          const signUpId = (actorSignUp.actorSignUpId ||
            actorSignUp.clientId)!.toString();
          setUserActorSignUpId(signUpId);
          const resp: any = await ActorRegistrationApi.createTrialCodeUser(
            getUserActorSignUpId(),
            serviceCode,
            aId,
            dId
          );
          const clientId = resp!.data.clientId;
          const jwtToken = resp!.data.jwt;
          if (jwtToken) {
            setUserAuthToken(jwtToken);
            let data = await getSessionDataFromAuthToken(jwtToken);
            let webSessionKey = data.WebSessionKey;
            setWebSessionKey(webSessionKey);
          }
          dispatch.actorModel.setClientId(clientId);
          dispatch.actorModel.setIsLoading(false);
        }
      } catch (resp) {
        if ((resp as any).status === 400) {
          dispatch.actorModel.setValidationError(true);
        } else {
          Sentry.captureException(resp);
          setUserActorSignUpId(null);
          setCurUserSignUp(null);
        }

        let apiResponseError = resp as IApiResponseError;
        if (apiResponseError.errors) {
          dispatch.actorModel.setErrors(
            getActorErrors(apiResponseError.errors)
          );
        } else if (apiResponseError.message) {
          dispatch.actorModel.setErrors({
            errorMessage: apiResponseError.message,
          });
        }
        console.error(resp);
      }
    },
    async saveActorSignUp(dto: IActorAccountDto, state: any) {
      cleanObjectProperties(dto);
      dispatch.actorModel.setValidationError(false);
      dispatch.actorModel.setIsLoading(true);
      await ActorRegistrationApi.createActorSignUp(getSessionId(), dto, dto.dev)
        .then((resp: any) => {
          dispatch.actorModel.setIsLoading(false);
          setCurUserSignUp(dto);
          let actorSignUp: IActorSignUpDto = resp!.data;
          if (actorSignUp) {
            dispatch.actorModel.setErrors({} as IActorError);
            setUserActorSignUpId(
              (actorSignUp.actorSignUpId || actorSignUp.clientId)!.toString()
            );
            setCustomCouponCode((actorSignUp.actorSignUpId || actorSignUp.clientId), actorSignUp?.couponCode);
            setCustomProductInfo((actorSignUp.actorSignUpId || actorSignUp.clientId), actorSignUp?.productCode, actorSignUp?.productServiceId);
            dispatch.actorModel.setCustomCouponCode(actorSignUp?.couponCode);
            dispatch.actorModel.setCustomProductInfo({ productCustomCode: actorSignUp.productCode, productServiceId: actorSignUp.productServiceId })
            dispatch.headerModel.setUserLoggedIn(true); // TODO:
          }
        })
        .catch((resp) => {
          dispatch.actorModel.setIsLoading(false);
          if (resp.status === 400) {
            dispatch.actorModel.setValidationError(true);
          } else {
            Sentry.captureException(resp);
            setUserActorSignUpId(null);
            setCurUserSignUp(null);
            dispatch.headerModel.setUserLoggedIn(false);
          }

          let apiResponseError: IApiResponseError = resp;
          if (apiResponseError.errors) {
            dispatch.actorModel.setErrors(
              getActorErrors(apiResponseError.errors)
            );
          } else if (apiResponseError.message) {
            dispatch.actorModel.setErrors({
              errorMessage: apiResponseError.message,
            });
          }
          console.error(resp);
        });
    },
    async getAccountInfo(guid, state: any) {
      dispatch.actorModel.setIsLoading(true);
      await ActorRegistrationApi.getAccountInfo(guid)
        .then((resp: any) => {
          dispatch.actorModel.setIsLoading(false);
          let accountInfo: IAccountInfo = resp!.data;
          if (accountInfo) {
            dispatch.actorModel.setErrors({} as IActorError);
            dispatch.actorModel.setAccountCredentials({
              ...accountInfo,
              workbookId: accountInfo.userId,
            });
          }
        })
        .catch((resp) => {
          Sentry.captureException(resp);
          dispatch.actorModel.setInvalidAccount(true);
          let apiResponseError: IApiResponseError = resp;
          if (resp.response && resp.response.data) {
            dispatch.actorModel.setErrors({
              errorMessage: resp.response.data.message,
            });
          } else if (apiResponseError.errors) {
            dispatch.actorModel.setErrors(
              getActorErrors(apiResponseError.errors)
            );
          } else if (apiResponseError.message) {
            dispatch.actorModel.setErrors({
              errorMessage: apiResponseError.message,
            });
          }
        });
    },
    async confirmAccount({ dto, guid }: any, state: any) {
      await ActorRegistrationApi.confirmAccount(dto.password, guid)
        .then((resp: any) => {
          if (resp.status === 200) {
            ActorRegistrationApi.loginAccount(dto).then((resp: any) => {
              if (resp.status === 200 && resp.data.accessToken) {
                const webSessionKey = JSON.parse(
                  atob(resp.data.accessToken.split(".")[1])
                );
                dispatch.actorModel.setAccountConfirmed(true);
                const qs = `tk=${webSessionKey.WebSessionKey}&cid=${dto.workbookId}&sch=${dto.sch}&saud=${dto.saud}`;
                window.localStorage.setItem("qs", qs);
              }
            });
          }
        })
        .catch((resp) => {
          Sentry.captureException(resp);
          let apiResponseError: IApiResponseError = resp;
          if (resp.response && resp.response.data) {
            dispatch.actorModel.setErrors({
              errorMessage: resp.response.data.message,
            });
          } else if (apiResponseError.errors) {
            dispatch.actorModel.setErrors(
              getActorErrors(apiResponseError.errors)
            );
          } else if (apiResponseError.message) {
            dispatch.actorModel.setErrors({
              errorMessage: apiResponseError.message,
            });
          }
        });
    },
    async createFreemiumUser(actorSignUpId: number) {
      return await ActorRegistrationApi.createFreemiumUser(actorSignUpId)
        .then(async (resp: any) => {
          try {
            const jwtToken = resp!.data.jwt;
            setUserAuthToken(jwtToken);
            let data = await getSessionDataFromAuthToken(jwtToken);
            let webSessionKey = data.WebSessionKey;
            setWebSessionKey(webSessionKey);
          } catch (err) {
            Sentry.captureException(err);
          } finally {
            return resp;
          }
        })
        .catch((resp) => {
          Sentry.captureException(resp);
          setCurUserSignUp(null);
          let apiResponseError: IApiResponseError = resp;
          if (apiResponseError.errors) {
            dispatch.actorModel.setErrors(
              getActorErrors(apiResponseError.errors)
            );
          } else if (apiResponseError.message) {
            dispatch.actorModel.setErrors({
              errorMessage: apiResponseError.message,
            });
          }
          console.error(resp);
          throw resp;
        });
    },
    async createTrialUser(actorSignUpId: number) {
      return await ActorRegistrationApi.createTrialUser(actorSignUpId)
        .then((resp: any) => resp)
        .catch((resp) => {
          Sentry.captureException(resp);
          setCurUserSignUp(null);
          let apiResponseError: IApiResponseError = resp;
          if (apiResponseError.errors) {
            dispatch.actorModel.setErrors(
              getActorErrors(apiResponseError.errors)
            );
          } else if (apiResponseError.message) {
            dispatch.actorModel.setErrors({
              errorMessage: apiResponseError.message,
            });
          }
          throw resp;
        });
    },
    async updateEmail({ clientId, email }) {
      await ProfileManagementApi.updateEmail(clientId, email)
        .then(() => { })
        .catch((e) => {
          Sentry.captureException(e);
          window.location.replace(process.env.REACT_APP_CWB_500);
        });
    },
    async checkSignupState(sessionId: string) {
      await SignupApi.getSignupState(btoa(sessionId))
        .then(resp => {
          dispatch.actorModel.setSignupStageStartup(resp.data.signUpStep);
          dispatch.actorModel.setActorCredentials(resp.data.signupCredentials);
          setCurUserSignUp(resp.data);
        })
        .catch(resp => {
          const { status } = resp;
          if (status >= 500) {
            Sentry.captureException(resp);
            errorPageRedirect();
            return;
          }

          if (resp.isAlreadyRegistered) {
            let params = new URLSearchParams();
            if (resp.clientId > 0) {
              params.append('login', resp.clientId)
            }
            window.location.assign(`${process.env.REACT_APP_CWB_Site}/login/go?${params}`);
            return;
          } else if (resp.isEmailAlreadyExists) {
            window.location.assign(`${process.env.REACT_APP_CWB_Site}/login`);
            return;
          }

          let apiResponseError: IApiResponseError = resp;
          console.error(resp);
          if (apiResponseError.errors) {
            dispatch.actorModel.setErrors(
              getActorErrors(apiResponseError.errors)
            );
          } else if (apiResponseError.message) {
            dispatch.actorModel.setErrors({
              errorMessage: apiResponseError.message,
            });
          }
          errorPageRedirect();


        });
    }
  }),
});

const getActorErrors = (apiErrors: IError[]): IActorError => {
  let errors = {} as IActorError;
  let validError = apiErrors.find(a => a.field && a.message);
  if (validError) {
    apiErrors.forEach((k: IError) => (errors[k.field] = k.message));
  } else {
    errors.errorMessage = apiErrors[0].toString();
  }

  return errors;
};

export default actorModel;